import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import TextField from 'Parts/ui/components/fields/TextField';

import TaxReceiptCampaignSettingsActivationModalContent_en from './locales/TaxReceiptCampaignSettingsActivationModalContent_en.json';
import TaxReceiptCampaignSettingsActivationModalContent_fr from './locales/TaxReceiptCampaignSettingsActivationModalContent_fr.json';

class TaxReceiptCampaignSettingsActivationModalContent extends React.Component {
  constructor(props) {
    super(props);

    i18next.addResourceBundle(
      'en',
      'TaxReceiptCampaignSettingsActivationModalContent',
      TaxReceiptCampaignSettingsActivationModalContent_en
    );
    i18next.addResourceBundle(
      'fr',
      'TaxReceiptCampaignSettingsActivationModalContent',
      TaxReceiptCampaignSettingsActivationModalContent_fr
    );
  }

  render() {
    const { t, form, switchActivated, handleConfirmInput, ticket } = this.props;
    const message = switchActivated ? t('activate-message' + (ticket ? '-ticket' : '')) : t('deactivate-message' + (ticket ? '-ticket' : ''));

    return (
      <React.Fragment>
        <p>{message}</p>
        <TextField form={form} onInput={handleConfirmInput} uppercase />
      </React.Fragment>
    );
  }
}

export default translate('TaxReceiptCampaignSettingsActivationModalContent')(
  TaxReceiptCampaignSettingsActivationModalContent
);
